import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { getAmount} from "../../redux/services/utility";
import { useState } from "react";

type Props = {
    bookingDetail: any;
    isBooking: boolean;
    parkingSpaceName?: any;
    customerData?: any;
    isLoggedIn?: boolean;
    parkingDetail?: any;
    values?: any;
    touched?: any;
    errors?: any;
    isRedeem?: boolean;
};

const BookingSummary = (props: Props) => {
    const [toggleButton, setToggleButton] = useState(false);
    console.log(props ,"props");

    const totalTax =
        props?.bookingDetail?.payload?.salesTaxAmount +
        props?.bookingDetail?.payload?.countyTaxAmount +
        props?.bookingDetail?.payload?.stateTaxAmount;


    return (
        <div className="bg-[#F9F4EF] p-6 mb-3 p-3 h-fit rounded-xl shadow-md">
            <div className="text-lg text-gray-600 font-semibold">Fare Summary</div>
            <div className="flex flex-col justify-between px-2 py-2">
                <div className="flex justify-between py-1">
                    <p className="text-base text-black text-start">Vehicle Charges</p>
                    <p className="text-base text-black ml-5 text-start">
                        ₹{(props?.bookingDetail?.payload?.totalAmount - props.bookingDetail?.payload?.tollCharges).toFixed(2)}
                    </p>
                </div>
                {props?.bookingDetail?.payload.discount > 0 && (
                    <div className="flex justify-between py-1">
                        <p className="text-base text-black text-start">
                            Discount ₹{" "}
                            {props?.bookingDetail?.payload.discountType === "%"
                                ? `(${props?.bookingDetail?.payload?.discount} ${props?.bookingDetail?.payload?.discountType})`
                                : ""}
                        </p>
                        <p className="text-base text-black ml-5 text-start">
                            -₹
                            {getAmount(
                                props?.bookingDetail?.payload?.discountType,
                                props?.bookingDetail?.payload?.totalAmount,
                                props?.bookingDetail?.payload?.discount
                            )}
                        </p>
                    </div>
                )}
                {props?.bookingDetail?.payload.offerDiscount > 0 && (
                    <div className="flex justify-between py-1">
                        <p className="text-base text-black text-start">Offer discount</p>
                        <p className="text-base text-black ml-5 text-start">
                            -₹{props?.bookingDetail?.payload?.offerDiscount?.toFixed(2)}
                        </p>
                    </div>
                )}
                <div className="flex flex-col justify-between">
                    <div
                        className="overflow-hidden"
                        style={{ height: toggleButton === false ? "35px" : "auto" }}
                    >
                        <div className="flex justify-between py-1">
                            <p className="text-base  flex items-center text-start">
                                Taxes
                                {toggleButton === false ? (
                                    <MdKeyboardArrowDown
                                        onClick={() => setToggleButton(true)}
                                    />
                                ) : (
                                    <MdKeyboardArrowUp
                                        onClick={() => setToggleButton(false)}
                                    />
                                )}
                            </p>
                            <p className="text-base   text-start">
                                ₹{totalTax?.toFixed(2)}
                            </p>
                        </div>
                        {props?.bookingDetail?.payload?.salesTaxAmount == null ||
                            props?.bookingDetail?.payload?.salesTaxAmount == 0 ? (
                            ""
                        ) : (
                            <div className="flex justify-between py-1">
                                <p className="text-base  flex items-center text-start">
                                CGST
                                </p>
                                <p className="text-base ml-5 text-start">
                                    ₹{props?.bookingDetail?.payload?.salesTaxAmount?.toFixed(2)}
                                </p>
                            </div>
                        )}
                       
                        {props?.bookingDetail?.payload?.stateTaxAmount == null ||
                            props?.bookingDetail?.payload?.stateTaxAmount == 0 ? (
                            ""
                        ) : (
                            <div className="flex justify-between py-1">
                                <p className="text-base  flex items-center text-start">
                                SGST
                                </p>
                                <p className="text-base  ml-5 text-start">
                                    ₹{props?.bookingDetail?.payload?.stateTaxAmount?.toFixed(2)}
                                </p>
                            </div>
                        )}
                    </div>
                    {props?.bookingDetail?.payload?.fixedFee == null ||
                        props?.bookingDetail?.payload?.fixedFee == 0 ? (
                        ""
                    ) : (
                        <div className="flex justify-between py-1">
                            <p className="text-base text-slate-500 flex items-center text-start">
                                Fixed Fee
                            </p>
                            <p className="text-base text-slate-500 ml-5 text-start">
                                ₹{ props?.bookingDetail?.payload?.fixedFee?.toFixed(2)}
                            </p>
                        </div>
                    )}
                    <div className="flex justify-between py-1">
                        <p className="text-base  text-start">
                            Convenience Fee
                        </p>
                        <p className="text-base  ml-5 text-start">
                            ₹{ props?.bookingDetail?.payload?.convenienceFee?.toFixed(2)}
                        </p>
                    </div>
                </div>
                {props.isRedeem && (
                    <div className="flex justify-between py-1">
                        <p className="text-base text-black text-start">Finder bucks</p>
                        <p className="text-base text-black ml-5 text-start">
                            ₹{props?.bookingDetail?.payload?.redeemAmount?.toFixed(2)}
                        </p>
                    </div>
                )}
            </div>
            <div className="flex justify-between px-2">
                <p className="text-base text-black text-start">Toll Charges</p>
                <p className="text-base text-black ml-5 text-start">
                    ₹{props?.bookingDetail?.payload?.tollCharges != null
                              ? props?.bookingDetail?.payload?.tollCharges.toFixed(2)
                              : "0.00"}
                </p>
            </div>
            <div className="flex flex-col justify-between px-2 py-5">
                <div className="flex justify-between py-1">
                    <p className="text-base font-semibold text-black text-start">Grand Total</p>
                    <p className="text-base font-semibold text-black ml-5 text-start">
                        ₹
                        {props?.bookingDetail?.payload?.finalAmount &&
                            props?.bookingDetail?.payload?.finalAmount.toFixed(2)}
                    </p>
                </div>
            </div>
        </div>

    );
};

export default BookingSummary;
